export const googleReview = {
	informations: "Vous pouvez choisir d’inclure un lien vers vos avis Google dans certains mails envoyés à vos patients. L’ID Google Avis que vous avez saisi sera utilisé pour générer automatiquement le lien. Le lien apparaîtra uniquement dans les mails correspondant aux options que vous aurez activées ci‑dessus (facture, suivi de consultation ou relance).",
	informations2: "Vous pouvez trouver cet identifiant dans l'URL de votre fiche Google: https://g.page/r/[VOTRE_ID]/review.",
	title: "Paramètres des avis Google",
	invoice: {
		title: "Inclure le lien Google Avis dans les mails de facture",
		label: "Facture"
	},
	follow_up: {
		title: "Inclure le lien Google Avis dans les mails de suivi de consultation",
		label: "Suivi de consultation"
	},
	relaunch: {
		title: "Inclure le lien Google Avis dans les mails de relance",
		label: "Relance"
	},
	'link-id': {
		label: "Identifiant Google Avis",
		title: "Identifiant Google Avis",
		placeholder: "Collez ici votre ID Google (ex : CaZdeEARu8OCER0)"
	},
	'button-title': "Prévisualiser le lien d’avis Google",
	'button-label': "aperçu du lien",
	'text-review': {
		label: "Texte de présentation des avis Google ({length})",
		placeholder: "ex : Votre avis est précieux et nous aide à améliorer la qualité de nos soins",
		title: "Veuillez renseigner le texte de présentation d’avis Google"
	},
	'remaining-characters': "{count} caractère restant|{count} caractère restant|{count} caractères restants",
	error: {
		'too-long': "Le texte de votre avis Google est trop long."
	},
}
